/** Show a `#tag` or `@tag` as a large format embed. */

import { LinkButton } from "./LinkButton.js";

const ALLOW = "encrypted-media; picture-in-picture; web-share; fullscreen";

const EMBEDS = new Map<RegExp, React.FunctionComponent<{ id: string; title?: string }>>([
	[/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|v\/)?([0-9A-Za-z_-]{10,16})/gi, YouTubeEmbed], //
]);

/** Show a `#tag` or `@tag` as a large format embed. */
export function LinkEmbed({ href, title }: { href: string; title: string }): React.ReactElement {
	for (const [regexp, Embed] of EMBEDS) {
		const matches = href.match(regexp);
		if (matches && typeof matches[1] === "string") return <Embed id={matches[1]} title={title} />;
	}

	// Anything else returns a standard link button.
	return <LinkButton href={href} title={title} />;
}

/** Embed a YouTube video. */
export function YouTubeEmbed({ id, title }: { id: string; title?: string }): React.ReactElement {
	return (
		<figure>
			<video>
				<iframe src={`https://www.youtube.com/embed/${id}`} allow={ALLOW} />
			</video>
			{title ? <figcaption>{title}</figcaption> : null}
		</figure>
	);
}

/** Embed a Vimeo video. */
export function VimeoEmbed({ id, title }: { id: string; title?: string }): React.ReactElement {
	return (
		<figure>
			<video>
				<iframe src={`https://player.vimeo.com/video/${id}`} allow={ALLOW} />
			</video>
			{title ? <figcaption>{title}</figcaption> : null}
		</figure>
	);
}
